var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"deleteTweetCont"}},[(
      _vm.toggleDeleteOn === false &&
      Number(_vm.currentUserInfo.userId) === Number(_vm.userId)
    )?_c('img',{staticClass:"actionIcon",attrs:{"src":require("@/assets/images/trash.svg"),"alt":"recycle bin icon - delete tweet button"},on:{"click":_vm.deleteComment}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }